import { CellContent } from '../ToDoTableContent';

export function KonfliktWrapper({
  root,
  cause,
  borderRoot = true,
  borderCause = true,
}: {
  root: React.ReactNode;
  cause: React.ReactNode;
  borderRoot?: boolean;
  borderCause?: boolean;
}) {
  return (
    <div className="flex flex-col">
      <CellContent
        border={borderRoot}
        className=" border-b-2 border-neutrals-N300">
        {root}
      </CellContent>
      <CellContent border={borderCause}>{cause}</CellContent>
    </div>
  );
}
